import React from 'react';
import FileList from './FileList2';
import { Controller } from 'react-hook-form';
import Preview from './FileList2/Preview';

const Campo = ({ campoPai = '', indiceLinha = '', campo, propsForm, remove }) => {
    const { valor = '', label = '', placeholder = '', tipo = '', opcoes = [] } = campo;
    const { register } = propsForm;
    const nome = campoPai ? `${campoPai.nome}[${indiceLinha}].${campo.nome}` : campo.nome;
    const desabilitado = campo?.desabilitado ? campo.desabilitado : campoPai?.desabilitado;

    let requerido = false;
    let mostrar = true;

    if (campo?.regras_visibilidade) {
        let assistir = [];
        campo.regras_visibilidade.forEach(regra => {
            for (let [regraCampo] of Object.entries(regra)) {
                if (campoPai) {
                    assistir.push(`${campoPai.nome}[${indiceLinha}].${regraCampo}`);
                } else {
                    assistir.push(regraCampo);
                }
            }
        });

        if (assistir.length > 0) {
            let watchFields = propsForm.watch(assistir);

            for (let iregra in campo.regras_visibilidade) {
                let regra = campo.regras_visibilidade[iregra];
                mostrar = true;
                for (let [regraCampo, regraValores] of Object.entries(regra)) {
                    let rc = regraCampo;
                    if (campoPai) {
                        rc = `${campoPai.nome}[${indiceLinha}].${regraCampo}`;
                    }
                    if (!Array.isArray(watchFields[rc])) {
                        watchFields[rc] = typeof watchFields[rc] === 'undefined' ? [] : [watchFields[rc]];
                    }
                    if (regraValores.every(v => watchFields[rc].includes(v))) continue;

                    mostrar = false;
                }
                if (mostrar) break;
            }
        }
    }

    if (mostrar === false) {
        if (tipo?.toLowerCase() === 'upload') {
            let linhaEscondida = 0;
            do {
                if (propsForm.getValues(`${nome}[${linhaEscondida}].chave`) === undefined) {
                    linhaEscondida = 0;
                } else {
                    propsForm.unregister(`${nome}[${linhaEscondida}].chave`);
                    propsForm.unregister(`${nome}[${linhaEscondida}].extensao`);
                    linhaEscondida++;
                }
            } while (linhaEscondida > 0);
        }
        propsForm.unregister(nome);
        return <></>;
    } else {
        if (campo?.regras_obrigatoriedade?.length > 0) {
            requerido = true;
        }
    }

    const obtemMsgErroObrigatorio = () => {
        return campoPai && propsForm?.errors[campoPai.nome] && propsForm.errors[campoPai.nome][indiceLinha] && propsForm.errors[campoPai.nome][indiceLinha][campo.nome]
            ? propsForm?.errors[campoPai.nome][indiceLinha][campo.nome]
            : propsForm.errors[campo.nome];
    };

    const montaMsgErroObrigatorio = () => {
        return obtemMsgErroObrigatorio() && <div className="invalid-feedback d-block">{campo.label}: Preenchimento obrigatório.</div>;
    };

    const montaInput = () => {
        switch (tipo?.toLowerCase()) {
            case 'text':
            case 'number':
                return (
                    <div className={'form-label-group' + (desabilitado === true ? ' disabled' : '') + (requerido ? ' required' : '') + (!!obtemMsgErroObrigatorio() ? ' destaque' : '')}>
                        {label && <label htmlFor={nome}>{label}</label>}
                        <input type={tipo} ref={register()} id={nome} name={nome} className="form-control" placeholder={placeholder ? placeholder : label} disabled={desabilitado === true} />
                        {montaMsgErroObrigatorio()}
                    </div>
                );
            case 'select':
                return (
                    <div className={'form-label-group form-select' + (desabilitado === true ? ' disabled' : '') + (requerido ? ' required' : '') + (!!obtemMsgErroObrigatorio() ? ' destaque' : '')}>
                        {label && <label htmlFor={nome}>{label}</label>}
                        <select ref={register()} id={nome} name={nome} className="form-control" size="1" disabled={desabilitado === true}>
                            <option value=""></option>
                            {opcoes?.map((opcao, index) => (
                                <option key={index} value={opcao.valor}>
                                    {opcao.label}
                                </option>
                            ))}
                        </select>
                        {montaMsgErroObrigatorio()}
                    </div>
                );
            case 'checkbox':
            case 'radio':
                return (
                    <section className={`form-${tipo}` + (requerido ? ' required' : '') + (!!obtemMsgErroObrigatorio() ? ' destaque' : '')}>
                        {label && <label>{label}</label>}
                        {opcoes?.map((opcao, index) => (
                            <div key={index} className={'form-check'}>
                                <input
                                    type={tipo}
                                    ref={register()}
                                    id={`${nome}_${index}`}
                                    name={nome}
                                    defaultValue={opcao.valor}
                                    defaultChecked={Array.isArray(valor) ? valor.includes(opcao.valor) : valor === opcao.valor}
                                    disabled={desabilitado === true}
                                />
                                {opcao.label && <label htmlFor={`${nome}_${index}`}>{opcao.label}</label>}
                            </div>
                        ))}
                        {montaMsgErroObrigatorio()}
                    </section>
                );
            case 'textarea':
                return (
                    <div className={'form-label-group' + (desabilitado === true ? ' disabled' : '') + (requerido ? ' required' : '') + (!!obtemMsgErroObrigatorio() ? ' destaque' : '')}>
                        {label && <label htmlFor={nome}>{label}</label>}
                        <textarea
                            ref={register()}
                            id={nome}
                            name={nome}
                            defaultValue={valor}
                            className="form-control"
                            placeholder={placeholder ? placeholder : label}
                            rows="2"
                            disabled={desabilitado === true}
                        ></textarea>
                        {montaMsgErroObrigatorio()}
                    </div>
                );
            case 'citacao':
                return (
                    <blockquote>
                        <div dangerouslySetInnerHTML={{ __html: label }} />
                    </blockquote>
                );
            case 'upload':
                if (desabilitado) {
                    return <Controller as={<VisualizaArquivos />} control={propsForm.control} modoLeitura={true} requerido={requerido} name={nome} label={campo.label} />;
                }
                return (
                    <FileList
                        nomeCampo={nome}
                        tipos_arquivos_aceitos={campo.arquivos_aceitos}
                        labelCampo={campo.label}
                        propsForm={propsForm}
                        remove={remove}
                        requerido={requerido}
                        msgErroObrigatorio={montaMsgErroObrigatorio()}
                    />
                );

            default:
                return <h1>Tipo de campo ({campo.tipo}) não definido</h1>;
        }
    };

    return montaInput();
};

const VisualizaArquivos = props => {
    return (
        <div className={'form-label-group' + (props.requerido ? ' required' : '')}>
            <label>{props.label}</label>
            <span className="text-muted d-flex">{props.value?.length ? props.value.length : 0} documento(s) enviado(s)</span>

            {props.value && (
                <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                    {props.value.map((arquivo, index) => (
                        <Preview key={index} index={index} modoLeitura={props.modoLeitura} arquivo={{ preview: arquivo.thumb }} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default Campo;
